import Vue from 'vue'
import VueHtml2Canvas from 'vue-html2canvas'
 
Vue.use(VueHtml2Canvas)

export default VueHtml2Canvas